<template>
  <CCard>
    <CModal
      :show.sync="showPreview"
      title="Preview"
      size="lg"
      :showCancelButton="false"
    >
      <div class="font-weight-bold mb-2">{{ campaign.mail_subject }}</div>
      <div
        class="border-top pt-2"
        v-html="templatePreview"
        :key="uploadHeaderCounter"
      ></div>
    </CModal>
    <CModal
      :show.sync="uploadFile"
      title="Upload New Header"
      size="sm"
      :showFooter="false"
    >
      <div class="mb-2">Click or drag & drop to upload header</div>
      <FileDragDropInput
        class="check-action"
        :allowedExtensions="['png', 'jpg', 'svg']"
        :multiple="false"
        disabled-label="File is already uploaded"
        @upload="uploadHeader"
      />
    </CModal>
    <CCardBody>
      <div class="d-flex">
        <div class="flex-2">
          <div>
            Veuillez insérer dans le mail les variables sous le format suivant :
            {nom_de_ma_variable}
          </div>
          <div>Voici la liste des variables disponibles : {{ availableFieldsText }}</div>
          <div>Une variable joue un rôle particulier: {start_survey_button}</div>
        </div>
        <div class="flex-1" style="display: flex; align-items: center; gap: 10px;">
          <CButton color="primary" @click="uploadFile = true">
            Insérer le header de la campagne
          </CButton>
          <CButton color="primary" class="mx-2" @click="showPreview = true">
            Prévisualiser l'email
          </CButton>
          <CButton color="primary" @click="saveTemplate">Sauvegarder le modèle</CButton>
        </div>
      </div>

      <CInput
        class="my-2"
        label="Objet"
        addInputClasses="mz-input"
        v-model="campaign.mail_subject"
      />
      <CTextarea
        label="Corps du texte"
        v-model="campaign.mail_template"
        addInputClasses="mz-input"
        :rows="30"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import { sanitize } from "dompurify";
import { CampaignService } from "@/services/campaign";
import { errorMessage } from "@/constants/common";
import {CampaignMixin} from "@/mixins/campaignMixin";
import {FilesService} from "../services/files";
import {CAMPAGNES_ENDPOINTS} from "../services/campaign";
import FileDragDropInput from "../components/FileDragDropInput";
import { BASE_URL } from '@/constants/config';

export default {
  name: "CampaignMail",
  components: { FileDragDropInput },
  mixins: [CampaignMixin],
  data() {
    return {
      exampleTemplateValues: {},
      showPreview: false,
      uploadFile: false,
      uploadHeaderCounter: 0,
      templateFields: [
        "en_tete_de_campagne",
        "en_tete_commun",
        "start_survey_button",
        "nom",
        "prenom",
        "certification_name",
        "ecole",
        "program",
        "date_jury",
        "promotion",
        "target_duree_post_diplome",
        "reponse_formulaire_url",
        "unsubscribe_url",
        "signataire",
        "privacy_policy_url",
        "title-xl",
        "title-xl-close",
        "title",
        "title-close",
        "text-xl",
        "text-xl-close",
        "text",
        "text-close",
        "text-s",
        "text-s-close",
        "red-text",
        "red-text-close",
        "align-right",
        "align-right-close",
        "divider",
        "divider-close"
      ],
    };
  },
  async mounted() {
    await this.fetchCampaign();
    await this.fetchExampleAlumni();
  },
  computed: {
    availableFieldsText() {
      return this.templateFields.map(field => `{${field}}`).join(', ');
    },
    templatePreview() {
      let templateText = this.campaign.mail_template;
      if (!templateText) {
        return;
      }
      templateText = this.sanitizeTemplate(templateText);
      templateText = templateText.replaceAll('\n', '<br/>')
      const templateFields = [...this.templateFields, "reponse_formulaire_url"];
      templateFields.forEach(
        (field) =>
          (templateText = templateText.replaceAll(
            `{${field}}`,
            this.exampleTemplateValues[field]
          ))
      );

      return `<span style='font-weight: 400; color: rgb(30, 29, 185); font-family: Manrope; font-size: 18px;'>${templateText}</span>`
    },
  },
  methods: {
    async uploadHeader(file) {
      await FilesService.uploadFile({
        file: file,
        url: CAMPAGNES_ENDPOINTS.base + this.campaign.id + '/',
        onError: (res) => {
          alert(res.detail);
          this.uploadFile = false;
          this.uploadHeaderCounter += 1;
        },
        onSuccess: () => {
          alert("Successfully uploaded file");
          this.fetchCampaign();
          this.fetchExampleAlumni();
          this.uploadFile = false;
          this.uploadHeaderCounter += 1;
        }
      });
    },
    sanitizeTemplate(template) {
      return sanitize(template, { USE_PROFILES: { html: false } });
    },
    async fetchExampleAlumni() {
      const data = await CampaignService.fetchCampaignAlumni(this.campaignId, {
        per_page: 1,
      });
      const exampleAlumni = data[0];
      if (!exampleAlumni) {
        return;
      }
      this.exampleTemplateValues = exampleAlumni.mail_template_values;
    },
    async saveTemplate() {
      const { res, data } = await CampaignService.updateCampaign(
        this.campaignId,
        {
          mail_template: this.sanitizeTemplate(this.campaign.mail_template),
          mail_subject: this.campaign.mail_subject,
        }
      );
      if (res.status === 200) {
        alert("Email template saved successfully");
        this.campaign = { ...data };
      } else {
        alert(errorMessage);
      }
    },
  },
};
</script>
